<template>
  <div class="px-4 py-2 border-t border-gray-200">
    <div class="flex items-center justify-between">
      <span class="text-sm text-gray-600">Debug 모드</span>
      <label class="relative inline-block w-10 h-5" title="디버그 모드 토글">
        <input
          type="checkbox"
          :checked="modelValue"
          @change="$emit('update:modelValue', $event.target.checked)"
          class="hidden"
        />
        <span
          class="absolute cursor-pointer inset-0 rounded-full transition-all duration-300"
          :style="{ backgroundColor: modelValue ? '#2563eb' : '#d1d5db' }"
        >
          <span
            class="absolute w-4 h-4 bg-white rounded-full left-0.5 top-0.5 transition-all duration-300"
            :style="{ transform: modelValue ? 'translateX(20px)' : 'translateX(0)' }"
          ></span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDebugMode',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.debug-disabled .cursor-pointer,
.debug-disabled [type="checkbox"]:disabled + span {
  cursor: not-allowed !important;
  opacity: 0.6;
}
</style>